export class AccordionElementStyle {
  marginTop = 'uk-margin-remove-top';

  static normalize(styles: Partial<AccordionElementStyle>): AccordionElementStyle {
    const pureStyles = new AccordionElementStyle();

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
